import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({

  selector: 'app-school-search-requests',

  templateUrl: './school-search-requests.component.html',

  styleUrls: ['./school-search-requests.component.css']

})

export class SchoolSearchRequestsComponent implements OnInit {

  lst_Requests = [];

  lst_Search = [];

  lst_RequestType = [];

  lst_MobileDomain = [];

  lst_Proceedings = [];

  objRequest: any = {};

  showCustom_Map: boolean = false;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    tiMadonik_RequestType: new FormControl('-1'),

    iMobileDomain: new FormControl('-1'),

    iMadonik_Request: new FormControl(''),

    strSDate: new FormControl(''),

    strEDate: new FormControl(''),

    strNationalID: new FormControl(''),

    strMobile: new FormControl(''),

  })

  mdl_Request: FormGroup = this.FormBuilder.group({

    fLon: new FormControl(''),

    fLat: new FormControl(''),

  });

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    this.getRequestType();

    this.getMobileDomain()

  }

  async getRequestType() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Madonik_RequestType_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'xq1567110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_RequestType = res;

  }

  async getMobileDomain() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`School_User_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'xq-01110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_MobileDomain = res;


  }

  filter_list(val: any) {

    this.lst_Requests = this.lst_Search.filter((el: any) => {

      return el.iMadonik_Request.toString().includes(val.value) ||

        el.strDate.toString().includes(val.value) ||

        el.strMadonik_RequestStatus_strComment.toString().includes(val.value) ||

        el.strPassenger_FullName.toString().includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Requests = this.lst_Search;

    }

  }

  async searchRequest() {

    let model = this.mdl_Search.value;

    model.iMadonik_Request = model.iMadonik_Request === "" ? -1 : model.iMadonik_Request;

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Madonik_Request_Search`, this._otherService.stringNumberToNumber(model))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'xq1`12110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Requests = res;

    this.lst_Search = res;

  }

  async openRequest(item) {

    let model = this.mdl_Search.value;

    model.iMadonik_Request = item.iMadonik_Request

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Madonik_Request_Info`, this._otherService.stringNumberToNumber(model))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12q1110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.objRequest = {};

    this.objRequest = res[0];

    console.log(this.objRequest)

    $("#detail_Modal").modal('show')


  }

  async openProceedings(item) {

    let model = this.mdl_Search.value;

    model.iMadonik_Request = this.objRequest.iMadonik_Request

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Madonik_Proceedings_List`, this._otherService.stringNumberToNumber(model))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'xqxas1110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Proceedings = res;

    $("#Proceedings_Modal").modal('show');


  }

  openMap(item) {

    if (item.fLat == 0 || item.fLon == 0) return this._tooltip.showError('مختصاتی یافت نشد')

    Object.keys(item).forEach(key => {

      this.mdl_Request.get(key)?.setValue(item[key])

    })

    this.showCustom_Map = false;

    setTimeout(() => {

      this.showCustom_Map = true;

    }, 10);


  }


  exportExcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'جستجو درخواست های-صدای دانش آموزان.xlsx');
  }


}
